// Import unified initialization system
import { initializeApplication } from './scripts/core/bootstrap.js';
import contextStore from './scripts/common/stores/contextStore.js';
// Bootstrap Modal import removed — all modals now use native <dialog>.
import { logger } from './scripts/utils/debug/logger.js';

// Styles
import './scss/main.scss'

// Assets contexts - Désactivé en développement pour améliorer les performances
// Seuls les assets nécessaires sont chargés à la demande
// require.context('./other', true);
// require.context('./images/icons', true);
// require.context('./images', true);

/**
 * Configure l'environnement de l'application, notamment pour gérer le cas
 * où l'application est servie via un proxy reverse
 */
function setupAppEnvironment() {
    // Utiliser le store de contexte pour détecter et configurer l'environnement
    // Le store initialise automatiquement:
    // - La détection iframe/proxy/direct
    // - Le basePath pour les ressources
    // - Les variables de compatibilité window.APP_CONFIG et window.APP_CONTEXT
    
    logger.initialization.info(`Application détectée en mode: ${contextStore.mode}`);
    logger.initialization.info(`Chemin de base configuré: ${contextStore.basePath}`);

    if (contextStore.isInIframe && contextStore.hasAuthParams()) {
        logger.initialization.info('Paramètres d\'authentification iframe détectés pour:',
                   contextStore.getUrlParam('email'));
    }
    
    // Pour maintenir la compatibilité avec le code existant qui utilise window.APP_CONFIG
    return window.APP_CONFIG;
}

/**
 * Gère l'affichage de l'alerte de confidentialité
 */
function handlePrivacyAlert() {
    const privacyAlert = document.getElementById('privacy-alert');
    const PRIVACY_ALERT_KEY = 'geneafan_privacy_dismissed';
    
    if (privacyAlert) {
        // Vérifier si l'utilisateur a déjà fermé l'alerte
        const isDismissed = localStorage.getItem(PRIVACY_ALERT_KEY) === 'true';
        
        if (isDismissed) {
            // Masquer l'alerte immédiatement si déjà fermée
            privacyAlert.style.display = 'none';
            privacyAlert.classList.remove('show');
        } else {
            // Écouter l'événement de fermeture
            privacyAlert.addEventListener('closed.bs.alert', function () {
                // Sauvegarder le choix de l'utilisateur
                localStorage.setItem(PRIVACY_ALERT_KEY, 'true');
                logger.initialization.debug('✓ Alerte de confidentialité fermée et mémorisée');
            });
        }
    }
}

// handleWelcomeModal removed — the hero section (fanHeroManager) replaced
// the welcome modal entirely. The #welcomeModal element no longer exists.

/**
 * Gère l'activation des alertes depuis le menu d'aide
 */
function handleActivateAlerts() {
    const activateAlertsBtn = document.getElementById('activateAlerts');
    
    if (activateAlertsBtn) {
        activateAlertsBtn.addEventListener('click', function (e) {
            e.preventDefault();
            
            // Réinitialiser les clés localStorage pour réactiver les alertes
            localStorage.setItem('geneafan_privacy_dismissed', 'false');
            localStorage.setItem('geneafan_welcome_dismissed', 'false');
            
            logger.initialization.debug('✓ Alertes réactivées - rechargement de la page');
            
            // Recharger la page pour afficher les alertes
            window.location.reload();
        });
    }
}

// Initialize with new system, fallback to old if needed
document.addEventListener("DOMContentLoaded", async () => {
    logger.initialization.info("Application initialization starting...");

    // Configurer l'environnement avant initialisation
    const appConfig = setupAppEnvironment();
    logger.initialization.info("Environnement configuré:", appConfig);
    
    try {
        // Try new initialization system
        await initializeApplication();
        logger.initialization.info("Application initialized successfully with new system");
        
        // Gérer l'alerte de confidentialité après l'initialisation
        handlePrivacyAlert();
    } catch (error) {
        logger.initialization.error("Error with new initialization system, falling back to old system:", error);
    }
});